import { schema } from "normalizr";

import { TranslatableMap } from "./localisation";
import { Album, NAlbum, Label, NLabel } from "./music";

interface Delivery {
    id: string;
    wata_job_id: number;
    album_id: number;
    upc: string;
    label_id: number;
    output: string;
    file_structure: string;
    dsp_id: number;
    created_at: Date;
    updated_at: Date;
    batch: Batch;
    type: Type;
    current_status: Status;
    statuses: Status[];
    album: Album;
    label: Label;
}

interface Batch {
    name: string;
    file_structure: string;
}

interface Type {
    name: string;
    label: TranslatableMap;
    description: string;
}

interface Status {
    type: StatusType;
    occurred_at: Date;
}

interface StatusType {
    name: string;
    label: TranslatableMap;
}

// Define the normalised version of the entities.
const NDeliveryBatch = new schema.Entity("deliveryBatches", {}, {
    idAttribute: "name",
});
const NDeliveryType = new schema.Entity("deliveryTypes", {}, {
    idAttribute: "name",
});
const NDeliveryStatusType = new schema.Entity("deliveryStatusTypes", {}, {
    idAttribute: "name",
});
const NDeliveryStatus = new schema.Entity("deliveryStatuses", {
    type: NDeliveryStatusType,
}, {
    idAttribute: (value: Status, parent: Delivery, key: string) => {
        let idx = parent.statuses.indexOf(value);
        if (key === "current_status") {
            idx = 0;
        }
        return parent.id + "_" + idx;
    },
});
const NDelivery = new schema.Entity("deliveries", {
    batch: NDeliveryBatch,
    type: NDeliveryType,
    current_status: NDeliveryStatus,
    statuses: [ NDeliveryStatus ],
    album: NAlbum,
    label: NLabel,
});

interface DeliveryNormalisedEntities {
    deliveries?: {
        [key: string]: Delivery;
    };
    deliveryBatches?: {
        [key: string]: Batch,
    };
    deliveryTypes?: {
        [key: string]: Type,
    };
    deliveryStatuses?: {
        [key: string]: Status,
    };
    deliveryStatusTypes?: {
        [key: string]: StatusType,
    };
}

export {
    Delivery,
    Batch,
    Type,
    Status,
    StatusType,
    NDeliveryBatch,
    NDeliveryType,
    NDeliveryStatusType,
    NDeliveryStatus,
    NDelivery,
    DeliveryNormalisedEntities,
};
